import { render, staticRenderFns } from "./HomeBestSellingProducts.vue?vue&type=template&id=593070dc&scoped=true&"
import script from "./HomeBestSellingProducts.vue?vue&type=script&lang=js&"
export * from "./HomeBestSellingProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeBestSellingProducts.vue?vue&type=style&index=0&id=593070dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593070dc",
  null
  
)

export default component.exports